import { Login } from '../../../features/auth/login';
import './auth.css';

const LoginPage = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export { LoginPage };
